import isNil from "lodash.isnil";
import { sendModerateBookAnalyticEvent } from "scripts/services/moderation/analytics";
const SELECTOR_SUBMIT_BUTTON = '[data-action="submit"]';
const SELECTOR_SUBMIT_TYPE_FLAG = 'input[data-type="submit"]';
const SELECTORS_FORM = [".block-on-submit", ".js-block-on-submit"];
/**
 * Need for check is correct template this code using
 * in all template with ".block-on-submit" and ".js-block-on-submit"
 *
 * @param form
 * @returns {*[]}
 */

const getStatusSelectors = form => {
  const entries = [...new FormData(form).entries()];
  return entries.filter(([name]) => name.indexOf("status") !== -1).map(([_, status]) => status);
};

const onSubmitForm = event => {
  // Reject default submit
  event.preventDefault();
  const {
    target: submittedForm,
    submitter: submitButton
  } = event; // eslint-disable-next-line no-unsafe-negation

  if (!(submittedForm instanceof HTMLElement)) {
    throw new Error("Not detect form");
  } // Disable if need submit button


  [...document.querySelectorAll(SELECTOR_SUBMIT_BUTTON)].forEach(item => {
    item.disabled = true;
  });
  const targetStatuses = getStatusSelectors(submittedForm); // Has less than 2 target status dropdown

  if (targetStatuses.length === 2) {
    // Update submit type flag for moderation button "Submit and save"
    const _submitTypeFlag = submittedForm.querySelector(SELECTOR_SUBMIT_TYPE_FLAG);

    if (!isNil(_submitTypeFlag)) {
      _submitTypeFlag.value = submitButton.name;
    } // Try send analytics for moderation book forms


    sendModerateBookAnalyticEvent(submittedForm, targetStatuses).then(() => {
      // Upon completion, a redirect occurs. There is an assumption
      // that the amplitude will not have time to send an event, so a
      // delay of 1 second is added
      setTimeout(() => submittedForm.submit(), 1000);
    }).catch(errMessage => {
      // if analytics fails, submit the form
      submittedForm.submit();
      throw new Error(errMessage);
    });
  } else {
    submittedForm.submit();
  }
};

const initFormLogic = () => {
  const blockedForms = [...document.querySelectorAll(SELECTORS_FORM)];
  blockedForms.forEach(form => form.addEventListener("submit", onSubmitForm));
};

document.addEventListener("DOMContentLoaded", initFormLogic);